<template>
  <div>
    <page-header :title="$t('bill.predict_management')" :tabs="cloudEnvOptions" :current-tab.sync="cloudEnv" />
    <page-body>
      <component :is="cloudEnv" />
    </page-body>
  </div>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import PredictAnalysis from './components/Analysis'
import PredictConfig from './components/Config'
import PredictImport from './components/Import'

export default {
  name: 'BillOverview',
  components: {
    PredictAnalysis,
    PredictConfig,
    PredictImport,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      cloudEnvOptions: [
        { key: 'predict-analysis', label: this.$t('bill.text_247') },
        { key: 'predict-config', label: this.$t('bill.predict_config') },
        { key: 'predict-import', label: this.$t('bill.predict_import') },
      ],
      cloudEnv: 'predict-analysis',
    }
  },
  methods: {
  },
}
</script>
